const route = {
	name: 'survey',
	path: 'survey',
	meta: {
		title: 'Encuestas',
	},
	redirect: 'survey/list',
	component: () => import('@/pages/polls/page-survey'),
	children: [
		{
			name: 'survey-list',
			path: 'list',
			component: () => import('@/pages/polls/page-poll'),
			meta: {
				title: 'Listado de Encuestas',
			},
			props: true,
			children: [
				{
					name: 'page-polls',
					path: ':id',
					meta: {
						title: 'Resolver encuesta',
					},
					components: {
						pollResolve: () => import('@/pages/polls/page-polls'),
					},
				},
			],
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/polls/index.js